module.exports = function ($stateProvider) {

	$stateProvider // Recipes
		.state('reviews', {
			abstract: true,
			parent: 'root'
		})
		.state('reviews.urlFriendlyName', {
			url: '/customer-reviews/:urlDisplayName/:shopperId',
			data: {
				authenticate: false,
				analytics: 'bws:web:customer-reviews',
				pageMetadata: {
					title: 'Customer Reviews',
					metaDescription: 'Customer Reviews',
					metaRobot: 'noindex, nofollow'
				}
			},
			views: {
				'center-panel@': {
					template: '<wow-review-overview view-mode="all">' +
									'<wow-standard-heading title="Customer Reviews"></wow-standard-heading>' +
								'</wow-review-overview>'
				}
			}
	});
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/configuration/routes/reviews.js
 **/